import { Injectable } from '@angular/core';


@Injectable()
export class JwtService {

  getToken(): String {
    return window.localStorage['jwtToken'];
  }

  saveToken(token: String) {
    window.localStorage['jwtToken'] = token;
  }

  destroyToken() {
    window.localStorage.removeItem('jwtToken');
    window.localStorage.removeItem('currentUser');
    localStorage.clear();
  }

  getUser(): any {
    if(window.localStorage['currentUser']){
      return JSON.parse(window.localStorage['currentUser']);
    }
  }

  saveUser(user: any) {
    window.localStorage['currentUser'] = JSON.stringify(user);
    window.sessionStorage['loggedInUser'] = JSON.stringify(user);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/jwt.service.ts